import { Component, OnInit, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { DashboardService } from "../../../../../services/dashboard.service";
import { SharedService } from "../../../../../services/shared.service";
import { BloccoModel } from "../../../../../models/dashboard/blocco.model";

@Component({
  selector: "app-http-data-form",
  templateUrl: "./http-data-form.component.html",
  styleUrls: ["./http-data-form.component.css"],
})
export class HttpDataFormComponent implements OnInit {
  @Input("form") form: FormGroup;

  blocco: BloccoModel;
  requests: Array<any> = [];
  constructor(
    private _dashboardService: DashboardService,
    private _sharedService: SharedService
  ) {}

  ngOnInit() {
    this._dashboardService.getAnagraficaRoutes().subscribe((res) => {
      this.requests = res;
      this.blocco = this._sharedService.getBlocco();
      if (this.blocco && this.blocco.idBloccoRouteAnagrafica) {
        this._sharedService.setRequest(
          this.requests.find(
            (req) => req.id === this.blocco.idBloccoRouteAnagrafica
          )
        );
      }
    });
  }

  onChangeReq(event) {
    this._sharedService.setRequest(
      this.requests.find((req) => req.id === event.value)
    );
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/http-data/http-data-form.component.ts